import React, { Component } from 'react'
import MediaQuery from 'react-responsive'
import { ThemeProvider } from 'emotion-theming'

import defaulttheme from '../../../../../constants/themeConstants'
import VideoComponentModal from '../../../../common/VideoComponentModal'

import EnquireNowButton from '../../../EnquireNowButton'

import {
  ImageAndContentContainer,
  FutureTextItem,
  FutureItemHead,
  FutureItemTitle,
  FutureImageItem,
  FutureSection,
  SectionImage,
  FutureItemImg,
  FutureItemDescription,
  MobileFutureItemDescription,
  ButtonContainer,
  ImageContainer,
  ContentContainer
} from './styledComponents'

const ContentSection = props => {
  const {
    futureItemTitle,
    futureItemDescription,
    galleryPresent,
    webpsrc,
    mainImage,
    mobileimage,
    formData,
    glsLoaded,
    buttonText,
    id
  } = props
  return (
    <FutureTextItem>
      <FutureItemTitle as="h3">{futureItemTitle}</FutureItemTitle>
      <FutureItemDescription>{futureItemDescription}</FutureItemDescription>
      <MediaQuery query="(max-device-width: 767px)">
        {galleryPresent ? (
          <FutureImageItem />
        ) : (
          <FutureItemHead id={futureItemTitle} onClick={props.handleOpenModal}>
            <MediaQuery query="(min-device-width: 768px)">
              <FutureItemImg
                onClick={props.handleOpenModal}
                dataSrc={webpsrc || mainImage}
                alt={futureItemTitle}
                className="lazyload"
              />
            </MediaQuery>
            <MediaQuery query="(max-device-width: 767px)">
              <FutureItemImg
                dataSrc={webpsrc || mobileimage}
                alt={futureItemTitle}
                className="lazyload"
              />
            </MediaQuery>
          </FutureItemHead>
        )}
      </MediaQuery>
      <MobileFutureItemDescription>
        {futureItemDescription}
      </MobileFutureItemDescription>
      <ButtonContainer>
        <EnquireNowButton
          formData={formData}
          glsLoaded={glsLoaded}
          text={buttonText}
          id={`${id}-enquire-button`}
        />
      </ButtonContainer>
    </FutureTextItem>
  )
}

const ImageSection = props => (
  <MediaQuery query="(min-device-width: 768px)">
    <FutureItemHead isEven={props.isEven}>
      <MediaQuery query="(min-device-width: 768px)">
        <SectionImage
          id={props.futureItemTitle}
          dataSrc={props.webpsrc || props.mainImage}
          onClick={props.handleOpenModal}
          alt={props.futureItemTitle}
          className="lazyload"
        />
      </MediaQuery>
    </FutureItemHead>
  </MediaQuery>
)

class Section extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalStatus: false
    }
  }

  handleOpenModal = () => {
    this.setState({ modalStatus: true })
  }

  handleCloseModal = () => {
    this.setState({ modalStatus: false })
  }

  renderContentVideoComponent = () => {
    const { modalStatus } = this.state
    const { videoId, isEven, id } = this.props
    return (
      <ImageAndContentContainer isEven={isEven}>
        <ImageContainer id={`${id}-video`} isEven={isEven}>
          <ImageSection
            {...this.props}
            handleOpenModal={this.handleOpenModal}
            align="left"
          />
          <VideoComponentModal
            isOpen={modalStatus}
            close={this.handleCloseModal}
            videoId={videoId}
          />
        </ImageContainer>
        <ContentContainer isEven={isEven}>
          <ContentSection
            {...this.props}
            handleOpenModal={this.handleOpenModal}
          />
        </ContentContainer>
      </ImageAndContentContainer>
    )
  }

  componentDidMount() {}
  render() {
    const { id } = this.props
    return (
      <ThemeProvider theme={defaulttheme}>
        <FutureSection id={id}>
          {this.renderContentVideoComponent()}
        </FutureSection>
      </ThemeProvider>
    )
  }
}

export default Section



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/ExperimentalMarketingSection/components/Section/index.js